import immutableRecords from "../../types/immutableRecords";

export default (narrativeRep, entityFoldersRep, customFields) => {
  const result = immutableRecords.SyncRepresentationRecord({
    documents: entityFoldersRep.documents.merge(narrativeRep.documents),
    documentTree: entityFoldersRep.documentTree.update("children", children =>
      children.unshift(narrativeRep.documentTree)
    ),
    customFields
  });
  return result;
};
